import { render, staticRenderFns } from "./DmBatchProfileHeader.vue?vue&type=template&id=30ba1d28&scoped=true&"
import script from "./DmBatchProfileHeader.vue?vue&type=script&lang=js&"
export * from "./DmBatchProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./DmBatchProfileHeader.vue?vue&type=style&index=0&id=30ba1d28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba1d28",
  null
  
)

export default component.exports